export default __webpack_public_path__ + "static/media/YAS0530.34I-27790_-17184_0.52c41804.jpg";